import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import Menu from "./Menu";

const AdminLayout = () => {
  return (
    <>
    <div className="wrapper">
      <Header />

      {/* <div style={{  width: "calc(100% - 30%)" }}> */}
      <Menu />
      {/* </div> */}
      
      {/* <div style={{  width: "calc(100% - 70%)" }}> */}
      <Outlet />
      {/* </div> */}

      {/* <Footer /> */}
    <div id="sidebar-overlay"></div>
    </div>
    </>
  );
};

export default AdminLayout;
